import { render } from "./VersionManagement.vue?vue&type=template&id=cef64cbe"
import script from "./VersionManagement.vue?vue&type=script&lang=js"
export * from "./VersionManagement.vue?vue&type=script&lang=js"

import "./VersionManagement.vue?vue&type=style&index=0&id=cef64cbe&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__